var map = {
	"./audio-placeholder": 640,
	"./audio-placeholder.png": 640,
	"./avatar-missing": 379,
	"./avatar-missing.png": 379,
	"./avatar-missing.svg": 954,
	"./header-missing": 381,
	"./header-missing.png": 381,
	"./soapbox-logo": 382,
	"./soapbox-logo-white": 383,
	"./soapbox-logo-white.svg": 383,
	"./soapbox-logo.svg": 382,
	"./video-placeholder": 641,
	"./video-placeholder.png": 641,
	"./void": 642,
	"./void.png": 642,
	"./web-push/web-push-icon_expand": 757,
	"./web-push/web-push-icon_expand.png": 757,
	"./web-push/web-push-icon_favourite": 758,
	"./web-push/web-push-icon_favourite.png": 758,
	"./web-push/web-push-icon_reblog": 759,
	"./web-push/web-push-icon_reblog.png": 759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 953;